<template>
  <div class="box wrapper-salary-receipt-perceptions">
    <div class="title-container is-flex">
      <h4 class="title is-centered is-4 has-text-primary title-salary-receipt-perceptions">
        Percepciones
      </h4>
      <div class="field is-centered">
        <BTooltip
          class="add-button"
          label="Agregar percepción"
          type="is-success"
        >
          <a
            class="button add-percept is-success is-rounded"
            @click="$store.commit('payroll/addPerceptRow')"
          >
            <BIcon icon="plus" />
          </a>
        </BTooltip>
      </div>
    </div>
    <BTable
      :data="perceptsWithIndex"
      :columns="columns"
      :opened-detailed="openedDetailed"
      :show-detail-icon="false"
      detailed
      detail-key="id"
      @details-close="onDetailsClose"
    >
      <template slot-scope="props">
        <BTableColumn
          field="concept"
          internal
        >
          <BField>
            <BInput
              name="concept"
              placeholder="Ingresa el concepto"
              :value="props.row.concept"
              required
              @input="onInput(props.row.id, 'concept', $event)"
            />
          </BField>
        </BTableColumn>
        <BTableColumn
          field="taxedAmount"
          internal
        >
          <BField>
            <BInput
              name="taxedAmount"
              placeholder="Ingresa monto"
              type="number"
              min="0"
              step="0.01"
              :value="props.row.taxedAmount"
              required
              @input="onInput(props.row.id, 'taxedAmount', $event)"
            />
          </BField>
        </BTableColumn>
        <BTableColumn
          field="actions"
          internal
        >
          <span class="actions">
            <a
              v-if="perceptsWithIndex.length > 1"
              class="button is-danger"
              @click="$store.commit('payroll/deletePercept', props.row.id)"
            >
              <BIcon
                icon="delete"
                aria-hidden="true"
              />
            </a>
          </span>
        </BTableColumn>
      </template>
      <template
        slot="detail"
        slot-scope="props"
      >
        <Overtime
          :id="props.row.id"
          :disabled="disabled"
        />
      </template>
    </BTable>
  </div>
</template>

<script>
import { perceptType as perceptTypeCatalog } from '@machete/common-catalogs';

const normalizeCatalog = ({ key, value }) => ({ value: key, label: value });

export default {
  name: 'PayrollPercepts',
  components: {
    Overtime: () => import(/* webpackChunkName: "invoice-concept-taxes" */ '@/components/Admin/Payroll/PayrollOvertime'),
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      perceptTypeCatalog: perceptTypeCatalog.map(normalizeCatalog),
      openedDetailed: [],
      showDetailIcon: false,
      columns: [
        { field: 'concept', label: 'Concepto', centered: true },
        { field: 'taxedAmount', label: 'Monto', centered: true },
        { field: 'actions', label: '', centered: true },
      ],
    };
  },
  computed: {
    perceptsWithIndex() {
      return this.$store.state.payroll.percepts.map((percept, index) => ({
        ...percept,
        id: index,
      }));
    },
  },
  methods: {
    onInput(index, name, value) {
      this.$store.commit('payroll/changePercept', { index, name, value });
    },
    onChange(index, name, value) {
      if (value === '019') {
        this.showDetailIcon = true;
        this.openedDetailed.push(index);
      } else {
        this.showDetailIcon = false;
        const indexOf = this.openedDetailed.indexOf(index);
        this.openedDetailed.splice(indexOf, 1);
      }
      this.$store.commit('payroll/changePercept', { index, name, value });
    },
    onDetailsClose(row) {
      const index = this.openedDetailed.indexOf(row.id);
      this.openedDetailed.slice(index, 1);
    },
    toggleDetail(id) {
      if (this.openedDetailed.includes(id)) {
        const index = this.openedDetailed.indexOf(id);
        this.openedDetailed.pop(index);
      } else {
        this.openedDetailed.push(id);
      }
    },
  },
};
</script>

<style scoped>
.title.is-4 {
  margin-bottom: 0;
}

.header-label {
  padding-right: 0.25rem;
}

.add-button {
  margin-right: 1.5rem;
}

.button.add-percept {
  padding-left: 0.75em!important;
  padding-right: 0.75em!important;
}

.button.add-percept .icon {
  margin-left: calc(-0.375em - 1px)!important;
  margin-right: calc(-0.375em - 1px)!important;
  font-size: inherit!important;
}

.add-percept-label {
  padding-left: .5rem;
}

.title-container {
  width: 100%;
  align-items: center;
  padding-bottom: .3rem;
  justify-content: space-between;
}

.limit-300 {
  width: 300px;
}
</style>
